/**
 * Sauvegarde les données dans le localStorage
 * @param {Object} data - Les données à sauvegarder
 */
export const saveToLocalStorage = (data) => {
    try {
      const serializedData = JSON.stringify(data);
      localStorage.setItem('calendarAppData', serializedData);
    } catch (error) {
      console.error('Erreur lors de la sauvegarde des données:', error);
    }
  };
  
  /**
   * Charge les données depuis le localStorage
   * @returns {Object|null} - Les données chargées ou null en cas d'erreur
   */
  export const loadFromLocalStorage = () => {
    try {
      const serializedData = localStorage.getItem('calendarAppData');
      if (serializedData === null) {
        return null;
      }
      return JSON.parse(serializedData);
    } catch (error) {
      console.error('Erreur lors du chargement des données:', error);
      return null;
    }
  };